export const External = [
    {
        key: 1,
        name: 'Tammy Dinh',
        image: require('static/team/external/tammy-dinh.jpg'),
        link: '',
    }, {
        key: 2,
        name: 'Krish Patel',
        image: require('static/team/external/krish-patel.jpg'),
        link: '',
    }, {
        key: 3,
        name: 'Megha Ravi',
        image: require('static/team/external/megha-ravi.jpg'),
        link: '',
    }, {
        key: 4,
        name: 'Vivien Truong',
        image: require('static/team/external/vivien-truong.jpg'),
        link: '',
    }, {
        key: 5, 
        name: 'Madhavan Venkatesh',
        image: require('static/team/external/madhavan-venkatesh.jpg'),
        link: '',
    },
];
